export type OperationalState = null | false | true;

export class Operation {
  private state: OperationalState = null;

  get busy() {
    return this.state === true;
  }

  get started() {
    return this.state !== null;
  }

  get completed() {
    return this.state === false;
  }


  of<WorkType>(work: Promise<WorkType>): Promise<WorkType> {
    this.start();
    return work.then((result) => {
      this.stop();
      return result;
    });
  }

  start() {
    this.state = true;
  }

  stop() {
    this.state = false;
  }

}
